/*
 * MONOCO Sticky CTA + バリアント選択（SP：ボトムシート ／ PC：バーの上のパネル）
 * - 独自 fetch はしない。カート追加は既存フォーム（product_form_id）の submit に乗せる
 * - 選択は本体 variant-selects の input を .click() して行う（状態は本体が唯一のソース）
 * - 数量は本体の Quantity-{section.id} を書き換える（本体が唯一のソース）
 * - 表示制御は本体 ProductSubmitButton の IntersectionObserver（SP・PC 共通）
 * - 売り切れ時の「再入荷通知を受け取る」は、本体にある StoreCRM の再入荷ボタンを click する
 *   （登録の仕組みは StoreCRM のものをそのまま使う。見つからなければ本体のボタン位置へスクロール）
 */
(function () {
  function boot() {
    var bars = document.querySelectorAll('sticky-cta');
    for (var i = 0; i < bars.length; i++) init(bars[i]);
  }

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  var RESTOCK_TEXT = /再入荷通知|入荷のお知らせ/;

  function isShown(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function init(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    var isSingle = bar.getAttribute('data-single') === 'true';
    var productInfo = document.getElementById('MainProduct-' + sectionId);
    var spQuery = window.matchMedia('(max-width: 749px)');

    function isPC() {
      return !spQuery.matches;
    }

    // ---- 表示制御：本体の追加ボタンが「画面より上」へ出たら表示 ----
    var target = document.getElementById('ProductSubmitButton-' + sectionId);
    if (target && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          each(entries, function (entry) {
            // ファーストビューで本体ボタンがまだ画面下にあるときは出さない
            var off = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', off);
            if (!off) closeSheet();
          });
        },
        { threshold: 0 }
      );
      io.observe(target);
    }

    // ---- シート ----
    var sheet = null;
    var matrix = [];
    var sheetId = bar.getAttribute('data-sheet-target');
    if (sheetId) {
      sheet = document.getElementById(sheetId);
      var mEl = sheet && sheet.querySelector('[data-sticky-matrix]');
      if (mEl) {
        try { matrix = JSON.parse(mEl.textContent) || []; } catch (e) { matrix = []; }
      }
    }

    // ---- 再入荷通知：本体の StoreCRM ボタンを探して click ----
    function isOurs(el) {
      return bar.contains(el) || (sheet && sheet.contains(el));
    }

    function findRestockButton() {
      var scope = productInfo || document;
      // 1) StoreCRM のブロック内のボタン
      var direct = scope.querySelectorAll(
        '[data-type="restock-button"] button, [data-type="restock-button"] a, [data-type="restock-button"] [role="button"]'
      );
      for (var i = 0; i < direct.length; i++) {
        if (!isOurs(direct[i]) && isShown(direct[i])) return direct[i];
      }
      // 2) 文言で探す（テキストを直接持つ要素だけ）
      var cands = scope.querySelectorAll('button, a, [role="button"], div, span');
      for (var j = 0; j < cands.length; j++) {
        var el = cands[j];
        if (isOurs(el) || el.children.length > 0) continue;
        var t = (el.textContent || '').trim();
        if (t.length > 30 || !RESTOCK_TEXT.test(t) || !isShown(el)) continue;
        return el.closest('button, a, [role="button"]') || el;
      }
      return null;
    }

    function triggerRestock() {
      var btn = findRestockButton();
      if (btn) {
        btn.click();
        return;
      }
      // 見つからない（登録済み表示など）→ 本体のボタン付近へ
      var anchor = document.getElementById('ProductSubmitButton-' + sectionId);
      if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    each(bar.querySelectorAll('[data-sticky-restock]'), function (btn) {
      btn.addEventListener('click', triggerRestock);
    });

    function bodyInputs() {
      var vs = document.getElementById('variant-selects-' + sectionId);
      if (!vs) return [];
      return [].slice.call(vs.querySelectorAll('[data-option-index]'));
    }

    function currentOptions() {
      var opts = [];
      bodyInputs().forEach(function (el) {
        var on =
          (el.tagName === 'OPTION' && el.selected) ||
          (el.tagName === 'INPUT' && el.checked);
        if (on) opts[parseInt(el.getAttribute('data-option-index'), 10)] = el.getAttribute('data-value');
      });
      return opts;
    }

    function selectedVariant() {
      if (!matrix.length) return null;
      if (isSingle) return matrix[0];
      var opts = currentOptions();
      for (var k = 0; k < matrix.length; k++) {
        var mo = matrix[k].options;
        if (mo.length !== opts.length) continue;
        var same = true;
        for (var n = 0; n < mo.length; n++) {
          if (mo[n] !== opts[n]) { same = false; break; }
        }
        if (same) return matrix[k];
      }
      return null;
    }

    // ---- 数量（PC）：本体の数量 input を操作 ----
    var qtyBox = bar.querySelector('[data-sticky-qty]');
    var lastSoldOut = false;

    function qtyInput() {
      // 本体はバリアント変更時に数量ブロックを差し替えるので毎回取り直す
      return document.getElementById('Quantity-' + sectionId);
    }

    function num(v, fallback) {
      var n = parseInt(v, 10);
      return isNaN(n) ? fallback : n;
    }

    function syncQty() {
      if (!qtyBox) return;
      var input = qtyInput();
      if (!input) { qtyBox.hidden = true; return; }
      // 売り切れ中は数量を出さない
      qtyBox.hidden = lastSoldOut;
      var val = num(input.value, 1);
      var min = num(input.getAttribute('min'), 1);
      var max = num(input.getAttribute('max'), Infinity);
      var valEl = qtyBox.querySelector('[data-qty-value]');
      if (valEl) valEl.textContent = val;
      each(qtyBox.querySelectorAll('[data-qty-step]'), function (btn) {
        var dir = parseInt(btn.getAttribute('data-qty-step'), 10);
        btn.disabled = dir < 0 ? val <= min : val >= max;
      });
    }

    if (qtyBox) {
      each(qtyBox.querySelectorAll('[data-qty-step]'), function (btn) {
        btn.addEventListener('click', function () {
          var input = qtyInput();
          if (!input) return;
          var dir = parseInt(btn.getAttribute('data-qty-step'), 10);
          var step = num(input.getAttribute('step'), 1) || 1;
          var min = num(input.getAttribute('min'), 1);
          var max = num(input.getAttribute('max'), Infinity);
          var next = num(input.value, min) + dir * step;
          if (next < min) next = min;
          if (next > max) next = max;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          syncQty();
        });
      });
    }

    function syncUI() {
      var v = selectedVariant();
      if (v) lastSoldOut = !v.available;
      syncQty();
      if (!v) return;
      var soldOut = lastSoldOut;

      each(bar.querySelectorAll('[data-sticky-price]'), function (el) { el.textContent = v.price; });
      var label = (v.options || []).join('／');
      each(bar.querySelectorAll('[data-sticky-variant]'), function (el) { el.textContent = label; });
      var thumb = bar.querySelector('[data-sticky-thumb]');
      if (thumb && v.img) thumb.src = v.img;

      // PC：カートに追加 ⇔ 再入荷通知
      var pcSubmit = bar.querySelector('[data-sticky-submit]');
      if (pcSubmit) pcSubmit.hidden = soldOut;
      each(bar.querySelectorAll('[data-restock-toggle]'), function (el) { el.hidden = !soldOut; });

      if (!sheet) return;
      var hp = sheet.querySelector('[data-sheet-price]');
      if (hp) hp.textContent = v.price;
      var th = sheet.querySelector('[data-sheet-thumb]');
      if (th && v.img) th.src = v.img;
      each(sheet.querySelectorAll('.variant-sheet__row'), function (row) {
        var on = row.getAttribute('data-variant-id') === String(v.id);
        row.classList.toggle('is-selected', on);
        row.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      // SP フッター：カートに追加 ⇔ 再入荷通知
      var submit = sheet.querySelector('[data-sheet-submit]');
      if (submit) submit.hidden = soldOut;
      var sheetRestock = sheet.querySelector('[data-sheet-restock]');
      if (sheetRestock) sheetRestock.hidden = !soldOut;
    }

    // 本体の選択・数量変更に追従（product-info は差し替えられないので安定して委譲できる）
    if (productInfo) {
      productInfo.addEventListener('change', function () { setTimeout(syncUI, 0); });
    }

    // ---- 開閉 ----
    var selectBtn = bar.querySelector('.sticky-cta__select');

    function placePanel() {
      if (!sheet) return;
      if (!isPC() || !selectBtn) {
        sheet.style.removeProperty('--sheet-left');
        return;
      }
      var r = selectBtn.getBoundingClientRect();
      var panelW = 360;
      var left = Math.min(Math.max(16, r.left), window.innerWidth - panelW - 16);
      sheet.style.setProperty('--sheet-left', left + 'px');
    }

    function openSheet() {
      if (!sheet) return;
      placePanel();
      sheet.hidden = false;
      if (!isPC()) document.documentElement.classList.add('sticky-sheet-open');
      if (selectBtn) selectBtn.setAttribute('aria-expanded', 'true');
      // reflow を挟んでトランジションを効かせる
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
      syncUI();
      var sel = sheet.querySelector('.variant-sheet__row.is-selected') || sheet.querySelector('.variant-sheet__row:not([disabled])');
      if (sel && isPC()) sel.focus({ preventScroll: true });
    }

    function closeSheet() {
      if (!sheet || sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('sticky-sheet-open');
      if (selectBtn) selectBtn.setAttribute('aria-expanded', 'false');
      var done = function () {
        if (!sheet.classList.contains('is-open')) sheet.hidden = true;
        sheet.removeEventListener('transitionend', done);
      };
      sheet.addEventListener('transitionend', done);
      setTimeout(done, 350);
    }

    each(bar.querySelectorAll('[data-open-sheet]'), function (btn) {
      btn.addEventListener('click', function () {
        if (sheet && !sheet.hidden && sheet.classList.contains('is-open')) closeSheet();
        else openSheet();
      });
    });

    if (spQuery.addEventListener) {
      spQuery.addEventListener('change', closeSheet);
    }
    window.addEventListener('resize', function () {
      if (sheet && !sheet.hidden) placePanel();
    });

    if (sheet) {
      each(sheet.querySelectorAll('[data-close-sheet]'), function (c) { c.addEventListener('click', closeSheet); });

      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && !sheet.hidden) {
          closeSheet();
          if (isPC() && selectBtn) selectBtn.focus();
        }
      });

      // 行クリック → 本体 variant picker を操作（独自状態は持たない）。売り切れ行も選べる
      each(sheet.querySelectorAll('.variant-sheet__row'), function (row) {
        if (row.disabled) return;
        row.addEventListener('click', function () {
          var id = row.getAttribute('data-variant-id');
          var entry = null;
          for (var m = 0; m < matrix.length; m++) {
            if (String(matrix[m].id) === id) { entry = matrix[m]; break; }
          }
          if (!entry) return;
          // 本体の画像切り替え・フォーカス移動でページが上に戻らないよう合図する（media-gallery.js / product-info.js が参照）
          window.MNCStickySelectAt = Date.now();
          var inputs = bodyInputs();
          // オプション軸ごとに、本体の対応 input を click（同一tick内なので差し替え前に完了）
          entry.options.forEach(function (val, idx) {
            for (var q = 0; q < inputs.length; q++) {
              var el = inputs[q];
              if (parseInt(el.getAttribute('data-option-index'), 10) !== idx) continue;
              if (el.getAttribute('data-value') !== val) continue;
              var checked =
                (el.tagName === 'INPUT' && el.checked) ||
                (el.tagName === 'OPTION' && el.selected);
              if (checked) break;
              if (el.tagName === 'OPTION') {
                el.selected = true;
                var sel = el.closest('select');
                if (sel) sel.dispatchEvent(new Event('change', { bubbles: true }));
              } else {
                el.click();
              }
              break;
            }
          });
          setTimeout(syncUI, 0);
          // PC は選んだらパネルを閉じ、バーのボタン（カートに追加／再入荷通知）で確定
          if (isPC()) {
            closeSheet();
            if (selectBtn) selectBtn.focus();
          }
        });
      });

      // SP フッター「カートに追加」= 既存フォーム submit。シートは閉じてカートを見せる
      var submit = sheet.querySelector('[data-sheet-submit]');
      if (submit) {
        submit.addEventListener('click', function () {
          if (submit.disabled) return;
          setTimeout(closeSheet, 0);
        });
      }

      // SP フッター「再入荷通知を受け取る」= シートを閉じてから StoreCRM の登録画面を開く
      // （本体のバリアント差し替えと StoreCRM ボタンの切り替えを待つため少し遅らせる）
      var sheetRestock = sheet.querySelector('[data-sheet-restock]');
      if (sheetRestock) {
        sheetRestock.addEventListener('click', function () {
          closeSheet();
          setTimeout(triggerRestock, 400);
        });
      }
    }

    // 本体側の数量 +/- ボタンは change を飛ばさない実装もあるので click でも追従
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('#Quantity-Form-' + sectionId)) setTimeout(syncQty, 0);
    });

    syncUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
